import store from "../store";
import { addProcentToTable } from './addProcentToTable';

export const getAllTable = () => {
  const table = store.getters.getPodhodit1.concat(store.getters.getPodhodit2);
  return addProcentToTable(table);
};
